var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<span>{{$ctrl.text}}{{$ctrl.dots}}</span>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/components/od-loading-text.jade
 ** module id = 3499
 ** module chunks = 3
 **/